import React from 'react'
import clsx from 'clsx'

import type { Flight } from '../../../state/models/flight'

import { FareLabels } from './FareItemBox';
import { FareItem } from './FareItem'
import { FareTooltip } from './FareTooltip'


type FlightTypesProps = {
  flight: Flight,
  selectedFlight: SelectedFlight,
  selectFlight?: (flight: SelectedFlight, fareSellKey: string) => void,
  currencyCode: string,
}

type SelectedFlight = {
  logicalFlightId: number,
  departureDate: string,
  fare: string, // fare type name
}

export function FlightFares({flight, selectedFlight, selectFlight, currencyCode}: FlightTypesProps) {

  const fares = Array.isArray(flight?.fares) ? flight.fares : []
  const handleFareClick = (fareTypeName: string, fareSellKey: string) => {
    if(typeof selectFlight !== 'function') return;

    const selection = {
      logicalFlightId: flight.logicalFlightId,
      departureDate: flight.departureDate,
      fare: fareTypeName,
    }
    selectFlight(selection, fareSellKey)    
  }

  return (
    <div className={clsx('tw-w-full tw-grid tw-gap-x-2', 
      'tw-grid-cols-1 md:tw-grid-cols-[200px_repeat(auto-fit,minmax(100px,1fr))]'
    )}>
      <FareLabels />
      {fares.map(fare => <FareItem key={fare.fareTypeName} fare={fare} currencyCode={currencyCode}
        onClick={(fareSellKey) => handleFareClick(fare.fareTypeName, fareSellKey)} 
        selected={checkSelectedFlight(selectedFlight, fare.fareTypeName, flight.logicalFlightId, flight.departureDate)}
      />)}
      {fares.map(fare => <FareTooltip key={fare.fareTypeName} fareTypeName={fare.fareTypeName} />)}
    </div>
  )
}

function checkSelectedFlight (selectedFlight: SelectedFlight, fareTypeName:string, logicalFlightId: number, departureDate: string) {
  return !selectedFlight 
    ? false 
    : selectedFlight.fare === fareTypeName
      && selectedFlight.logicalFlightId === logicalFlightId
      && selectedFlight.departureDate === departureDate;
}